import { useTranslation } from 'react-i18next';

const styles = {
  container: 'max-w-[1080px] mx-auto px-4 sm:px-6 lg:px-8 py-6',
  title: 'text-3xl font-bold text-gray-900 mb-10',
  sectionTitle: 'text-lg font-bold text-gray-800 mt-8 mb-4',
  paragraph: 'text-base text-gray-700 mb-4'
};

export const CookiesNoticePage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>{t('cookiesNoticePage.title')}</h1>
      <p className={styles.paragraph}>{t('cookiesNoticePage.introduction')}</p>

      <h2 className={styles.sectionTitle}>{t('cookiesNoticePage.strictlyNecessaryTitle')}</h2>
      <p className={styles.paragraph}>{t('cookiesNoticePage.strictlyNecessaryContent')}</p>

      <h2 className={styles.sectionTitle}>{t('cookiesNoticePage.performanceTitle')}</h2>
      <p className={styles.paragraph}>{t('cookiesNoticePage.performanceContent')}</p>

      <h2 className={styles.sectionTitle}>{t('cookiesNoticePage.functionalTitle')}</h2>
      <p className={styles.paragraph}>{t('cookiesNoticePage.functionalContent')}</p>

      <h2 className={styles.sectionTitle}>{t('cookiesNoticePage.marketingTitle')}</h2>
      <p className={styles.paragraph}>{t('cookiesNoticePage.marketingContent')}</p>

      <h2 className={styles.sectionTitle}>{t('cookiesNoticePage.managingTitle')}</h2>
      <p className={styles.paragraph}>{t('cookiesNoticePage.managingContent')}</p>

      <h2 className={styles.sectionTitle}>{t('cookiesNoticePage.deletingTitle')}</h2>
      <p className={styles.paragraph}>{t('cookiesNoticePage.deletingContent')}</p>

      <h2 className={styles.sectionTitle}>{t('cookiesNoticePage.managePreferencesTitle')}</h2>
      <p className={styles.paragraph}>{t('cookiesNoticePage.managePreferencesContent')}</p>

      <h2 className={styles.sectionTitle}>{t('cookiesNoticePage.changesTitle')}</h2>
      <p className={styles.paragraph}>{t('cookiesNoticePage.changesContent')}</p>
    </div>
  );
};
